module.exports = __webpack_public_path__ + "static/media/avatar.a91357a7.svg";